import React from 'react'
import ReactSVG from 'react-svg'

import Button from '../../button'
import styles from './render-icon-button.css'

export default function renderIconButton(onClick, key, buttonStyle, text, icon) {
  return (
    <Button
      className={styles.buttonContainer}
      onClick={onClick}
      key={key}
      type="submit"
      e2eIdentifier={text}
      secondary
    >
      <div
        className={buttonStyle}
      >
        {icon && (
          <ReactSVG src={icon} />
        )}
        {text}
      </div>
    </Button>
  )
}
